import {
    Autocomplete,
    Avatar,
    Box,
    Container,
    CssBaseline,
    Grid,
    LinearProgress,
    Paper,
    TextField,
    Typography } from "../ui";
import React,
    { useCallback,
    useEffect,
    useRef,
    useState } from "react";
import { NotificationContainer,
    NotificationManager } from "react-notifications";
import { useDispatch,
    useSelector } from "react-redux";
import Navbar from '../navbar/Navbar';
import Sidebar from '../sidebar/Sidebar';
import { Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate } from "react-router-dom";
import BillConnector from "../billing/BillConnector";
import OwnerDashboard from './OwnerDashboard';
import Configuration from '../configuration/Configuration';
import Category from '../Category';
import ProductEntry from '../product/mart/ProductEntry';
import ShowProduct from '../product/ShowProduct';
import SupplierInfo from '../supplier/SupplierInfo';
import LockOutlinedIcon from "../ui/icons/LockOutlined";
import Employee from '../employee/Employee';
import StockEntry from '../stockentry/StockEntry';
import Conversion from '../customunit/Conversion';
import RestoProductStock from '../resturant/RestoProductStock';
//import BillingModule from '../billing/BillingModule';
import BillingTable from '../billing/BillingTable';
import BookTable from '../booktable/BookTable';
import ComboOffer from '../combooffer/ComboOffer';
//import RestoBillingModule from '../billing/bill/RestoBillingModule';
import ShowBills from '../billing/ShowBills';
import HelpModule from '../help/HelpModule';
import ThemeManager from '../theme/ThemeManager';
import A2zVoiceSettings from '../voice/A2zVoiceSettings';
import PrinterConfig from '../printer/PrinterConfig';
import SilentPrintDecisionManager from '../printer/SilentPrintDecisionManager';
import Profile from '../profile/Profile';
import Customer from '../customer/Customer';
import Accounting from '../accounting/Accounting';
import ItemSaleDashboard from './ItemSaleDashboard';
import RestoStockInformation from '../resturant/RestoStockInformation'
import ReturnWasteBill from '../billing/ReturnWasteBill';
import RiderDashBoard from '../rider/RiderDashboard';
import ReceipeV2 from '../receipe/ReceipeV2';
import KitchenUI from '../kitchen/KitchenUI';
import ReportGeneration from '../report/ReportGeneration';
import CouponManagementFrame from '../coupon/CouponManagementFrame';
import ScreenNotificationScreen from "../notification/SnpNotificationScreen";
import GeneralNotificationDialog from "../notification/GeneralNotificationDialog";
import Loader from "../global/loader/Loader";
import SnpChatApp,
    { useSnpChatPublicApi } from '../Chatengine/SnpChatApp';
import {
  ACTMGMT,
  BILLMGMT,
  getAuthSession,
  CartDets,
  CHANGEPASSWORD,
  COMBOFOODITEMGMT,
  COMBOMGMT,
  CUSTOMERRIDERAPP,
  CUSTOMERMGMT,
  CUSTOMIZEDCONFIG,
  CUSTOMUNITMGMT,
  DashboardComponent,
  EMPMGMT,
  FOODITEMPRODUCTMGMT,
  getPreUrlAccordingToCart,
  GETPRODDETAILS,
  InternalBillType,
  INVSTOCKMGMT,
  isFeatureAllowed,
  isNumberEmpty,
  local_test_url,
  LOGOUT,
  offline_enable,
  ORDERRECEIVED,
  KITCHEN_ORDER,
  KITCHEN_ORDER_STATUS_UPDATE,
  GENERAL_NOTIFICATION,
  KITCHENMGMT,
  OWNERDASHBOARD,
  Print_Log,
  printDebugLog,
  printInfoLog,
  RECPMGMT,
  REPGEN,
  RETURNWASTEMGMT,
  ROLEUPDATE,
  setLogout,
  SHOWITEMWISESALES,
  STOCKMGMT,
  SUCCESS,
  SUPMGMT,
  updateKitchenSessionState,
  updateSessionState,
  test_environment_mode,
  THEMEMGMT,
  UPDATEACTIVESHOPSESSION,
  UPDATEHOMEDELIVERY,
  VALIDITYEXPIREDERR,
  EMPSALARYMGMT,
  CHATSUPPMGMT,
  isRoleAllowed,
  ONLINEBILLMGMT,
  RECHARGEPORTAL,
  VOICEMGMT,
  COUPONMANAGEMENT,
  ROLE_VIEW,
  ROLE_CREATE,
  ROLE_UPDATE
} from "../../constants/constant";
import { setActiveShopHash, setBaseCateogoryData, setCartType } from "../../actions";
import { snpAxios } from "../global/api";
import "./Dashboard.css";
import 'react-notifications/lib/notifications.css';
import ConfirmDialog from "../global/ConfirmDialog";
import FeatureGuard from "../global/FeatureGuard";
import { isEmpty } from "lodash";
import SnpButton from "../global/SnpButton";
import DismissButton from "../global/DismissButton";
import axios from "axios";
import utilities from "../../utilities/utilities";
import { getQueryParam } from '../../utilities/queryParamUtils';
import DialogBox from "../global/DialogBox";
import MartBilling from "../billing/MartBilling";
import uiUtilInstance from "../../utilities/uiUtil";
import RestoBillingModuleV2 from "../billing/resto-billing/RestoBillingModuleV2";
import RestoKeyboardBase from "../billing/keyboardbill/RestoKeyboardBase";
import RestoBillingModule from "../billing/RestoBillingModule";
import MartReturnWasteBill from "../billing/MartReturnWasteBill";
import EmployeeSalaryBase from "../employee/EmployeeSalaryBase";
import AddProductBase from "../product/AddProductBase";
import MinimumOrderDistance from "../configuration/MinimumOrderDistance";
import GoldSupplierRecord from "../product/gold/GoldSupplierRecord";
import ShowGoldSupplierRecord from "../product/gold/ShowGoldSupplierRecord";
import GoldPdp from "../goldcart/GoldPdp";
import OnlineWatchBill from "../billing/onlinebilling/OnlineWatchBill";
import { createCartWebSocket } from "../createCartWebSocket";
import ChatSound from "../Chatengine/context/ChatSound";
import { getBaseNotificationCount } from "./dashboardNetworkController";
import SnpFcmNotification from "../notification/SnpFcmNotification";
import { CHAT_BASE_URL, CHAT_SOCKET_BASE_URL } from "../Chatengine/utils/SnpChatConstant";
import { encodeWithDigit, getRandomTwoDigitNumber } from "../Chatengine/utils/SnpChatUtils";
import PaymentInformation from "../accounting/PaymentInformation";
import Recharge from "../rechargePortal/Recharge";
import MarketingPage from "../marketing/MarketingPage";
import RestoBillingModuleV3 from "../billing/resto-billing/RestoBillingModuleV3";
import VoiceCommandListener from "../voice/VoiceCommandListener";
import { getSettingFromIndexedDB } from "../global/indexedDB";
import { DEFAULT_VOICE_SETTINGS, normalizeVoiceSettings, VOICE_COMMANDS, VOICE_SETTINGS_KEY } from "../voice/voiceSettings";
import GlobalRestoProductSearch from "./GlobalRestoProductSearch";
import GlobalRestoBulkStock from "./GlobalRestoBulkStock";
import GlobalComboSearch from "./GlobalComboSearch";


export default function Dashboard() {
  const storeActiveShopHash = useSelector(state => state.setActiveShopHashReducer.activeShopHash);
  const storeApiUrl = useSelector(state => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const socketRef = useRef(null);
  const reSnpSocketNotificationConnectTimer = useRef(null);
  const activeCartTypeRef = useRef(storeActiveShopHash.cartType);
  const activeChefValue = storeActiveShopHash?.isChef ?? getAuthSession().isChef;
  const isChefEnabled = Number(storeActiveShopHash?.cartType) === CartDets.Resto
    && (activeChefValue === true || activeChefValue === 'true' || activeChefValue === 1 || activeChefValue === '1');

  const KEEP_ALIVE_INTERVAL = test_environment_mode ? 60 * 60 * 1000 : 5 * 60 * 1000; // 1 minutes to 45 sec to 5 min
  const INITIAL_MESSAGE = {
    message: '',
    show: false,
    audioSrc: "",
    oldPassWord: "",
    newPassWord: ""
  };

  const INITIAL_DIALOG_CONTENT = {
    showDialog: false,
    title: "",
    subTitle: "",
    negativeReq: true,
    negativeAction: "",
    positiveReq: false,
    positiveAction: "",
    iconReq: false,
    cancelConfirmExtra: false,
    outsideClickedConfirmDismiss: false,
    onHandleCancel: () => { },
  };

  const INITIAL_STOCK_CONTENT = {
    id: "",
    details: "",
    type: "",
    variant: "",
    size: "",
    liveStockData: "",
    liveStockOnlineData: "",
    expiryLiveStockData: "",
    freeLiveStockData: "",
    cnvDetails: "",
    rack_no: "",
  };


  const [open, setOpen] = useState(true);
  const [count, setCount] = useState(0);
  const [loader, setLoader] = useState(false);
  const [searchLoader, setSearchLoader] = useState(false);
  const [loggedOut, setLogoutUser] = useState(false);
  const recentWebSocketNotifications = useRef(new Map());
  const handleSocketMessageRef = useRef(null);
  const [fcmNotification, setFcmNotification] = useState(INITIAL_MESSAGE);
  const [generalNotifications, setGeneralNotifications] = useState([]);
  const [expiryDialog, setExpiryDialog] = useState(INITIAL_MESSAGE);
  const [passwordDialog, setPasswordDialog] = useState(INITIAL_MESSAGE);
  const [lockDialog, setLockDialog] = useState(INITIAL_MESSAGE);

  useEffect(() => {
    if (lockDialog.show) {
      document.body.dataset.snpScreenLocked = "true";
    } else {
      delete document.body.dataset.snpScreenLocked;
    }

    return () => {
      delete document.body.dataset.snpScreenLocked;
    };
  }, [lockDialog.show]);
  const [searchDialog, setSearchDialog] = useState(INITIAL_MESSAGE);
  const [confirmDialog, setConfirmDialog] = useState(INITIAL_DIALOG_CONTENT);
  const [voiceSettings, setVoiceSettings] = useState(DEFAULT_VOICE_SETTINGS);
  const [lastVoiceCommand, setLastVoiceCommand] = useState(null);
  const [globalRestoSearchOpen, setGlobalRestoSearchOpen] = useState(false);
  const [globalRestoBulkStockOpen, setGlobalRestoBulkStockOpen] = useState(false);
  const [globalComboSearchOpen, setGlobalComboSearchOpen] = useState(false);
  const [globalComboId, setGlobalComboId] = useState("");

  const [isGetStockDetails, setIsGetStockDetails] = useState(false);
  const [listDataAvail, setListDataAvail] = useState(false);
  const [listStock, setListStock] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [stockDetails, setStockDetails] = useState(INITIAL_STOCK_CONTENT);
  const [inactive, setInactive] = useState(false);
  const [isChatMounted, setIsChatMounted] = useState(false);
  let inactivityTimer;

  useEffect(() => {
    activeCartTypeRef.current = storeActiveShopHash.cartType;
  }, [storeActiveShopHash.cartType]);

  useEffect(() => {
    const loadVoiceSettings = async () => {
      try {
        setVoiceSettings(normalizeVoiceSettings(await getSettingFromIndexedDB(VOICE_SETTINGS_KEY)));
      } catch (error) {
        console.error("Unable to load voice settings:", error);
      }
    };

    const applySavedVoiceSettings = (event) => {
      setVoiceSettings(normalizeVoiceSettings(event.detail));
    };

    loadVoiceSettings();
    window.addEventListener("a2z-voice-settings-updated", applySavedVoiceSettings);
    return () => window.removeEventListener("a2z-voice-settings-updated", applySavedVoiceSettings);
  }, []);


  const handleItemSearchChange = (event) => {
    if (event) {
      setInputValue(event.target.value);
    }
  }

  const logoutUser = async () => {
    try {
      setLoader(true);
      setConfirmDialog(INITIAL_DIALOG_CONTENT);
      const logouturl = `${storeApiUrl.BACKEND_BASE_URL}${LOGOUT}`;
      const data = { jcJson: { value_1: getAuthSession().apiToken, } };
      const response = snpAxios.post(logouturl, data);
      printDebugLog("logoutUser", response);
      sessionStorage.removeItem("carInitialState");
      useSnpChatPublicApi.deRegisterKey();
      setLogout();
      dispatch(setCartType(CartDets.All));
      setLoader(false);
      setLogoutUser(true);
    } catch (error) {
      console.error("logoutUser errr ", error);
      sessionStorage.removeItem("carInitialState");
      dispatch(setCartType(CartDets.All));
      setLogout();
      setLogoutUser(true);
    }
  };

  const handleChangePwd = async () => {
    if (isEmpty(passwordDialog.oldPassWord)) {
      setPasswordDialog(prvs => ({
        ...prvs, message: "Old Password cannot be empty"
      }));
      return;
    }
    if (isEmpty(passwordDialog.newPassWord)) {
      setPasswordDialog(prvs => ({
        ...prvs, message: "New Password cannot be empty"
      }));
      return;
    }
    if (passwordDialog.oldPassWord === passwordDialog.newPassWord) {
      setPasswordDialog(prvs => ({
        ...prvs, message: "Old Password and new Password can't be same"
      }));
      return;
    }
    try {
      setLoader(true);
      const logouturl = `${storeApiUrl.BACKEND_BASE_URL}${CHANGEPASSWORD}`;
      const data = {
        jcJson: {
          apiToken: getAuthSession().apiToken,
          value_1: passwordDialog.newPassWord,
          value_2: passwordDialog.oldPassWord,
        }
      };
      const response = await snpAxios.post(logouturl, data);
      if (response.data.status === SUCCESS) {
        updateSessionState({ firstTimeLogin: false });
        setPasswordDialog(INITIAL_MESSAGE);
        setConfirmDialog({
          ...confirmDialog,
          showDialog: true,
          subTitle: "SuccessFully Changed the Password! Please Login Again.",
          positiveAction: "Login!",
          positiveReq: true,
          negativeReq: false,
        })
      } else {
        setPasswordDialog(prvs => ({ ...prvs, message: "Current password is wrong" }));
      }
      setLoader(false);
    } catch (error) {
      console.error("handleChangePwd errr ", error);
      setLoader(false);
    }
  };

  const getProductDetails = async (stock) => {
    try {
      setSearchLoader(true);
      const productDetails = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}${GETPRODDETAILS}?adminId=${getAuthSession().apiToken}&stock=${stock}&shopHash=${storeActiveShopHash.id}&type=${storeActiveShopHash.cartType}`;
      const response = await axios.get(productDetails, {});
      if (response.data.status === SUCCESS) {
        setListStock(response.data.jcJson.value_2);
      } else {
        setListStock([]);
      }
      setSearchLoader(false);
    } catch (error) {
      console.error("getProductDetails error : ", error);
      setSearchLoader(false);
    }
  };

  const signIn = async () => {
    try {
      if (isEmpty(lockDialog.oldPassWord)) {
        setLockDialog(prvs => ({
          ...prvs, message: "Please enter password & sign in!"
        }));
        return;
      }
      setLoader(true);
      const mPwd = utilities.encode(lockDialog.oldPassWord);
      const mUrl = `${storeApiUrl.BACKEND_BASE_URL}a2z-token-refresh?token=${getAuthSession().apiToken}&val=${mPwd}`;
      const response = await axios.get(mUrl, {});
      printDebugLog("signIn response => ", response.data);
      setLoader(false);
      if (response.data.status === SUCCESS) {
        updateSessionState({ apiToken: response.data.jcJson.token });
        sessionStorage.setItem('a2zApiToken', response.data.jcJson.token);
        setLockDialog(INITIAL_MESSAGE);
      } else {
        setLockDialog(prvs => ({
          ...prvs, message: "Entered password is wrong. Try again",
          oldPassWord: "",
        }));
      }
    } catch (error) {
      setLoader(false);
      console.error("signIn error : ", error);
      setLockDialog(prvs => ({
        ...prvs, message: "Something wrong. Try again",
        oldPassWord: "",
      }));
    }
  };

  const updateCartValue = (event, selectedHash) => {
    setExpiryDialog(INITIAL_MESSAGE);
    setLoader(true);
    if (selectedHash != null) {
      const cartUrl = `${storeApiUrl.BACKEND_BASE_URL}${UPDATEACTIVESHOPSESSION}`;
      const data = { jcJson: { apiToken: getAuthSession().apiToken, shopHash: selectedHash.id }, };
      snpAxios
        .post(cartUrl, data)
        .then((response) => {
          // console.log("response  => ", response.data);
          printDebugLog("updateCartValue", response.data);
          if (response.data.status === SUCCESS) {
            const payLoad = response.data.jcJson;
            const responseShopHash = updateKitchenSessionState({
              ...selectedHash,
              defScreen: payLoad.defScreen,
              companyName: payLoad.companyName,
              companyWebAddress: payLoad.companyWebAddress,
              companyMail: payLoad.companyMail,
              packages: payLoad.packages,
              onlineDelvMethod: payLoad.onlineDelvMethod,
              validity: payLoad.validity,
              totalValidity: payLoad.totalValidity,
              startDate: payLoad.startDate,
              originalStartDate: payLoad.originalStartDate,
              defBalanceType: payLoad.defBalanceType,
              kotCopiesAllowed: payLoad.kotCopiesAllowed,
              defBillUi: Number(payLoad.defBillUi),
            }, payLoad);
            dispatch(setActiveShopHash(responseShopHash));
            dispatch(setCartType(responseShopHash.cartType));
            const worker = new Worker(new URL('../billing/GetDataFromDbWorker.js', import.meta.url));
            worker.postMessage(responseShopHash.id);
            worker.onmessage = (e) => {
              let savedData = e.data;
              printDebugLog("GetDataFromDbWorker Profile", savedData);
              if (savedData !== undefined && savedData.data !== undefined) {
                if (!"fullData" === savedData.type) {
                  dispatch(setBaseCateogoryData(savedData.data.value));
                }
              }
            };

            worker.onerror = (error) => {
              console.log("Worker error:", error);
            };

            NotificationManager.success("", "Changed to " + selectedHash.shop + "\nsuccessfully done.");
          } else {
            NotificationManager.error("Changed to " + selectedHash.shop + "\not happen.Try again!");
          }
        })
        .catch((error) => {
          console.error("updateCartValue errr ", error);
          if (VALIDITYEXPIREDERR === error.code) {
            handleThrowValidityErrorByShop(error.message);
          } else {
            NotificationManager.error("Changed to " + selectedHash.shop + "\nnot happen.Try again!");
          }
        });
    }
  };


  /* Only Function Call */

  const getKeyByValue = (CartDets, value) => {
    //console.log("getKeyByValue",CartDets,value);
    return value.location + "(" + Object.keys(CartDets).find(key => CartDets[key] === value.cartType) + ")";
  }
  const handleUpdateStockDetails = (ev, option) => {
    printDebugLog("handleUpdateStockDetails", option);
    if (option != null) {
      //console.log("handleUpdateStockDetails", event, option);
      setStockDetails(option);
      setListStock([]);
      setIsGetStockDetails(true);
      setListDataAvail(!option.noStock);
      setInputValue('');
    } else {
      setStockDetails(INITIAL_STOCK_CONTENT);
      setIsGetStockDetails(false);
      setListDataAvail(false);
    }
  };
  const clearStockDetails = () => {
    setIsGetStockDetails(false);
    setStockDetails(INITIAL_STOCK_CONTENT);
    setListStock([]);
    setListDataAvail(false);
  };
  const handleSearch = (event) => {
    const { name, value } = event.target;
    //console.log(name,value)
    if (name === 'gsd') {
      setIsGetStockDetails(true);
    } else if (name === 'lse') {
      const mPrdId = stockDetails.id;
      setSearchDialog(INITIAL_MESSAGE);
      clearStockDetails();
      navigate("/dashboard/stockentry", { state: { prdId: mPrdId, isEditStock: 1 } });
    } else if (name === 'sb') {
      const mPrdId = stockDetails.id;
      setSearchDialog(INITIAL_MESSAGE);
      clearStockDetails();
      navigate("/dashboard/billentry", { state: { prdId: mPrdId } });
    } else {
      if (value.length >= 3) {
        clearStockDetails();
        getProductDetails(value);
      }
    }
  };

  const handleSignInKeyDown = (evt) => {
    if (["Enter", "Tab", ","].includes(evt.key)) {
      evt.preventDefault();
      signIn();
    }
  };

  const toggleDrawer = () => {
    setOpen(!open);
  };

  const handleLoader = (loaded) => {
    setLoader(loaded);
  };

  const offlineLogout = () => {
    window.opener = null;
    window.open("", "_self");
    window.close();
  };

  const handleThrowValidityErrorByShop = (msg) => {
    setExpiryDialog({
      ...expiryDialog, message: msg, show: true
    })
  };

  const setComponentIndex = (index) => {
    printDebugLog("setComponentIndex", index);
    switch (index) {
      case DashboardComponent.LOGOUTMESSAGE:
        setConfirmDialog({
          ...confirmDialog,
          showDialog: true, title: "Logout!",
          subTitle: "Do You Want to Logout", negativeAction: "No",
          positiveReq: true
        });
        break;
      case DashboardComponent.LOGOUT:
        logoutUser();
        break;
      case DashboardComponent.PASSWORDDIALOG:
        setPasswordDialog({
          ...passwordDialog, show: true,
        });
        break;
      case DashboardComponent.SEARCHDIALOG:
        setSearchDialog({
          ...searchDialog, show: true, oldPassWord: "",
        });
        break;
      case DashboardComponent.LOCKDIALOG:
        document.body.dataset.snpScreenLocked = "true";
        setLockDialog({
          ...lockDialog, show: true, oldPassWord: "",
        });
        break;
      default:
        console.warn("setComponentIndex default ", index);
    }
    setOpen(false);
  };

  const showDialogBox = (msg) => {
    setConfirmDialog({
      ...confirmDialog,
      showDialog: true,
      subTitle: msg,
      negativeAction: "Got It!",
    });
  };

  const checkPersistence = async () => {
    if ('storage' in navigator && 'persist' in navigator.storage) {
      try {
        const persistent = await navigator.storage.persist();
        if (persistent) {
          console.info("Storage will not be cleared except by explicit user action");
        } else {
          console.warn("Storage may be cleared by the UA under storage pressure.");
        }
      } catch (err) {
        console.error('Error requesting persistent storage:', err);
      }
    } else {
      console.warn("Storage is not available");
    }
  };

  const inititateNotification = () => {
    if (!("Notification" in window)) {
      console.info("Browser does not support desktop notification");
    } else {
      Notification.requestPermission();
      printDebugLog("Browser support notification");
    }
  };

  const getDefaultNullScreen = () => {
    if (storeActiveShopHash.cartType === CartDets.Gold) {
      return <ShowProduct />;
    }
    return null;
  }

  const getDefaultScreen = () => {
    return getAuthSession().defScreen === DashboardComponent.REPORTMANAGEMENT
      ? isFeatureAllowed(OWNERDASHBOARD) ? <OwnerDashboard /> : getDefaultNullScreen()
      : getAuthSession().defScreen === DashboardComponent.BILLDETAILS
        ? isFeatureAllowed(BILLMGMT) ? <BillingTable showDialogBoxWithPaper={showDialogBox} voiceCommand={lastVoiceCommand} setVoiceCommandClear={() => setLastVoiceCommand(null)} /> : getDefaultNullScreen()
        : getAuthSession().defScreen === DashboardComponent.BILLCONNECTOR
          ? isFeatureAllowed(BILLMGMT) ? <BillConnector voiceCommand={lastVoiceCommand} setVoiceCommandClear={() => setLastVoiceCommand(null)} /> : getDefaultNullScreen()
          : getAuthSession().defScreen === DashboardComponent.ONLINE_BILL_MANAGEMENT
            ? isFeatureAllowed(ONLINEBILLMGMT) ? <OnlineWatchBill /> : getDefaultNullScreen()
            : getAuthSession().defScreen === DashboardComponent.RESTO_BILLING_UI
              ? isFeatureAllowed(BILLMGMT) ? <Navigate replace to="/dashboard/billentry" /> : getDefaultNullScreen()
              : getDefaultNullScreen()
  };

  const handleRoleUpdate = () => {
    setConfirmDialog({
      ...confirmDialog,
      showDialog: true, title: "Role Updated!",
      subTitle: "Your Role is Updated! Please SignIn Again", positiveAction: "Sign Out",
      positiveReq: true,
      outsideClickedConfirmDismiss: false,
      cancelConfirmExtra: true,
    });
  }

  const showTrayNotifications = (title, body, url) => {
    if (navigator.serviceWorker && Notification.permission === 'granted') {
      navigator.serviceWorker.ready.then(registration => {
        return registration.showNotification(title, {
          body,
          icon: "/logo192.png",
          badge: "/logo192.png",
          image: "/logo512.png",
          requireInteraction: true,
          vibrate: [200, 100, 200, 100, 300],
          tag: "notification_" + new Date().getTime(),
          renotify: true,
          data: {
            url: url,
          }
        }).then(() => console.info("[NOTIFICATION_TRACE] SYSTEM_NOTIFICATION_SHOWN", {
          source: "dashboard",
          title,
          url,
        })).catch((error) => console.error("[NOTIFICATION_TRACE] SYSTEM_NOTIFICATION_FAILED", error));
      });
    } else {
      console.warn("[NOTIFICATION_TRACE] SYSTEM_NOTIFICATION_SKIPPED", {
        permission: 'Notification' in window ? Notification.permission : 'unsupported',
        serviceWorkerSupported: Boolean(navigator.serviceWorker),
      });
    }
  }

  const handleSocketMessage = (obj, source = "websocket", delivery = {}) => {
    console.info("[NOTIFICATION_TRACE] EVENT_RECEIVED", { source, obj, delivery });
    const status = Number(obj?.status);
    const payLoad = obj?.jcJson || {};
    const notificationKey = payLoad.notificationId || JSON.stringify(obj);
    const now = Date.now();
    for (const [key, receivedAt] of recentWebSocketNotifications.current) {
      if (now - receivedAt > 30000) recentWebSocketNotifications.current.delete(key);
    }
    if (recentWebSocketNotifications.current.has(notificationKey)) {
      console.info("[NOTIFICATION_TRACE] EVENT_DEDUPLICATED", {
        source,
        notificationId: payLoad.notificationId,
        status,
      });
      return;
    }
    recentWebSocketNotifications.current.set(notificationKey, now);

    const isUserNotification = [ORDERRECEIVED, GENERAL_NOTIFICATION, KITCHEN_ORDER]
      .includes(status);
    if (isUserNotification) {
      const title = payLoad.title || (status === ORDERRECEIVED ? "New Order Received"
        : status === KITCHEN_ORDER ? "New Kitchen Order" : "A2Z Notification");
      const body = payLoad.body || (payLoad.billNo ? `Order ${payLoad.billNo}` : "You have a new update");
      const url = payLoad.url || (status === ORDERRECEIVED && payLoad.billNo
        ? `/dashboard/billentry?bNo=${encodeURIComponent(payLoad.billNo)}`
        : status === KITCHEN_ORDER || status === KITCHEN_ORDER_STATUS_UPDATE ? "/dashboard/kitchen" : "");
      const sound = localStorage.getItem("notificationSound") || "order_received_grab.mp3";
      setFcmNotification({ show: true, audioSrc: `/${sound}` });
      console.info("[NOTIFICATION_TRACE] SOUND_REQUESTED", {
        source,
        notificationId: payLoad.notificationId,
        audioSrc: `/${sound}`,
      });
      if (!delivery.systemNotificationShown) {
        showTrayNotifications(title, body, url || "/dashboard");
      } else {
        console.info("[NOTIFICATION_TRACE] SYSTEM_NOTIFICATION_ALREADY_SHOWN", {
          source,
          notificationId: payLoad.notificationId,
        });
      }
    }
    if (!isNumberEmpty(obj.status)) {
      if (parseInt(obj.status) === UPDATEHOMEDELIVERY) {
        updateSessionState({ homeDelvMethod: obj.jcJson.homeDelvMethod });
        //console.log('Received message2:', getAuthSession);
      } else if (parseInt(obj.status) === ROLEUPDATE) {
        updateSessionState({ roles: obj.jcJson.roles, otherRoles: obj.jcJson.otherRoles ?? {} });
        handleRoleUpdate();
        //console.log('Received message3:', getAuthSession);
      } else if (parseInt(obj.status) === ORDERRECEIVED) {
        const payLoad = obj.jcJson;
        //playAudio();
        const mTitle = isEmpty(payLoad.title) ? "New Order Received" : payLoad.title;
        const mBody = isEmpty(payLoad.body) ? "Home Delivery" : payLoad.body;
        const billNo = isEmpty(payLoad.billNo) ? "" : payLoad.billNo;
        const billType = isNumberEmpty(payLoad.billType) ? InternalBillType.Home : Number(payLoad.billType ?? InternalBillType.Home);

        printDebugLog('Received message: ORDERRECEIVED (obj):', obj);
        printDebugLog('Received message: ORDERRECEIVED (mTitle):', mTitle);
        printDebugLog('Received message: ORDERRECEIVED (mBody):', mBody);
        printDebugLog('Received message: ORDERRECEIVED (billNo):', billNo);

        //https://www.npmjs.com/package/react-notifications
        NotificationManager.info(mTitle, <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{mBody}</p>, 18000, () => {
          navigate("/dashboard/billentry", {
            state: {
              tableProps: {},
              sBillNo: billNo,
              billType: billType
            }
          });
        });
        getBaseNotificationCount(storeApiUrl.BACKEND_BASE_URL, storeActiveShopHash, (count) => {
            setCount(count);
        });
        // const audio = new Audio(wavFile);
        // audio.play();

        //Old code
        // navigator.serviceWorker.register('sw.js');
        // Notification.requestPermission(function(result) {
        //   if (result === 'granted') {
        //     console.log('showNotification granted');
        //     navigator.serviceWorker.getRegistrations().then(function(registrations) {
        //       registrations[0].showNotification(mTitle, options);
        //     });

        //   } else 
        //     console.log('showNotification disabled');
        // });

      } else if (parseInt(obj.status) === GENERAL_NOTIFICATION) {
        const payLoad = obj.jcJson || {};
        setGeneralNotifications((current) => [...current, {
          ...payLoad,
          type: payLoad.type || payLoad.notificationType || "text",
          imageUrl: payLoad.imageUrl || payLoad.image,
          youtubeUrl: payLoad.youtubeUrl || payLoad.videoUrl,
          youtubeVideoId: payLoad.youtubeVideoId || payLoad.videoId,
          dismissible: payLoad.dismissible ?? !payLoad.block,
          notificationId: payLoad.notificationId || `${Date.now()}-${Math.random()}`,
        }]);
      } else if (isChefEnabled && isFeatureAllowed(KITCHENMGMT)
        && (parseInt(obj.status) === KITCHEN_ORDER || parseInt(obj.status) === KITCHEN_ORDER_STATUS_UPDATE)) {
        const payLoad = obj.jcJson || {};
        const kitchenEvent = { ...payLoad, status: parseInt(obj.status) };
        window.dispatchEvent(new CustomEvent('snp-kitchen-notification', { detail: kitchenEvent }));
        const kitchenTrayEnabled = payLoad.kitchen_notifcation_tray
          ?? getAuthSession().kitchenNotificationTray;
        if (parseInt(obj.status) === KITCHEN_ORDER && kitchenTrayEnabled
          && 'Notification' in window && source !== "websocket") {
          const title = 'New kitchen order';
          const body = payLoad.billNo ? `Order ${payLoad.billNo} is waiting` : 'A new order is waiting';
          if (Notification.permission === 'default') {
            Notification.requestPermission().then((permission) => {
              if (permission === 'granted') showTrayNotifications(title, body, '/dashboard/kitchen');
            });
          } else if (Notification.permission === 'granted') {
            showTrayNotifications(title, body, '/dashboard/kitchen');
          }
        }
      }
    }
  };

  handleSocketMessageRef.current = handleSocketMessage;
  const handleFirebaseNotificationMessage = useCallback((message, source, delivery) => {
    try {
      handleSocketMessageRef.current?.(JSON.parse(message), source || "firebase", delivery);
    } catch (error) {
      console.error("Invalid Firebase notification message", error);
    }
  }, []);

  const handleKeyDown = (e) => {
    //e.preventDefault();
    //console.log("handleKeyDown",storeActiveShopHash.cartType);
    const activeCartType = Number(activeCartTypeRef.current);
    if (e.ctrlKey && e.altKey && (e.code === 'Digit4' || e.key === '4') && activeCartType === CartDets.Resto) {
      e.preventDefault();
      if (isRoleAllowed(STOCKMGMT, ROLE_UPDATE)) {
        setGlobalRestoSearchOpen(false);
        setGlobalComboSearchOpen(false);
        setGlobalRestoBulkStockOpen(true);
      } else {
        showDialogBox("You Are not allowed to Add/Update Stock Details.Contact the Owner");
      }
    } else if ((e.metaKey || (e.ctrlKey && e.altKey)) && e.code === 'KeyE') {
      navigate("/dashboard/employee");
    } else if ((e.metaKey || (e.ctrlKey && e.altKey)) && e.code === 'KeyC') {
      navigate("/dashboard/cateogory");
    } else if ((e.metaKey || (e.ctrlKey && e.altKey)) && e.code === 'KeyI') {
      navigate("/dashboard/itementry");
    } else if ((e.metaKey || (e.ctrlKey && e.altKey)) && e.code === 'KeyR') {
      navigate("/dashboard/itementry");
    } else if ((e.metaKey || (e.ctrlKey && e.altKey)) && e.code === 'KeyB') {
      if (activeCartType === CartDets.Resto) {
        navigate("/dashboard/billentry", { state: { tableProps: {}, sBillNo: "", billType: InternalBillType.TakeAway } });
      } else {
        navigate("/dashboard/billentry");
      }
    } else if ((e.metaKey || (e.ctrlKey && e.altKey)) && e.code === 'KeyP') {
      navigate("/dashboard/profile");
    } else if ((e.metaKey || (e.ctrlKey && e.altKey)) && e.code === 'KeyA') {
      navigate("/dashboard/accounting");
    } else if ((e.metaKey || (e.ctrlKey && e.altKey)) && e.code === 'KeyS' && activeCartType === CartDets.Resto) {
      e.preventDefault();
      if (isRoleAllowed(STOCKMGMT, ROLE_UPDATE)) {
        setGlobalRestoSearchOpen(true);
      } else {
        showDialogBox("You Are not allowed to Add/Update Stock Details.Contact the Owner");
      }
    } else if ((e.metaKey || (e.ctrlKey && e.altKey)) && e.code === 'KeyM' && activeCartType === CartDets.Resto) {
      e.preventDefault();
      if (isRoleAllowed([INVSTOCKMGMT, FOODITEMPRODUCTMGMT], ROLE_CREATE)) {
        setGlobalComboSearchOpen(true);
      } else {
        showDialogBox("You Are not allowed to Update Combo Details.Contact the Owner");
      }
    } else if ((e.metaKey || (e.ctrlKey && e.altKey)) && e.code === 'KeyL') {
      setComponentIndex(DashboardComponent.LOCKDIALOG)
    } else if ((e.metaKey || (e.ctrlKey && e.altKey)) && e.code === 'KeyQ' && activeCartType === CartDets.Resto) {
      navigate("/dashboard/billhandler", { state: { quickBillCheck: true } });
    }
    resetInactivityTimer();
  };

  const handleMouseMove = () => {
    //console.log("handleMouseMove");
    resetInactivityTimer();
  };

  const resetInactivityTimer = () => {
    if (!inactive && getAuthSession().defInactitivityTime !== -1) {
      clearTimeout(inactivityTimer);
      startInactivityTimer();
    }
  };

  // Start the inactivity timer
  const startInactivityTimer = () => {
    //defInactitivityTime it should come greater than 1 minute
    const inactivityTime = getAuthSession().defInactitivityTime * 60 * 1000;
    inactivityTimer = setTimeout(() => {
      setInactive(true);
      setComponentIndex(DashboardComponent.LOCKDIALOG);
    }, (inactivityTime)); // Set the duration of inactivity in milliseconds (e.g., 5000 = 5 seconds)
  };

  useEffect(() => {
    printDebugLog("location.state", location.state);
    if (location.state?.showFeatureInactiveDialog) {
      showDialogBox("This Feature is Inactive.Contact Spark N Pass for Enable")
    } else if (location.state?.logout) {
      setComponentIndex(DashboardComponent.LOGOUT);
    }
  }, [location.state]);

  //https://blog.bitsrc.io/how-to-use-desktop-notifications-with-react-122536954dc2
  useEffect(() => {
    setOpen(false);
    checkPersistence();
    Print_Log.DEBUG_ENABLED = test_environment_mode ? true : getQueryParam('debug') === '1';
    Print_Log.NEW_RESTO = getQueryParam('nr') === '1';
    printInfoLog("DEBUG_ENABLED in Prod", Print_Log.DEBUG_ENABLED);
    printInfoLog("New Resto Enabled", Print_Log.NEW_RESTO);
    inititateNotification();

  }, []);



  useEffect(() => {
    const keepAlive = () => {
      //axios.get('http://localhost:7071/snp-local-print/heartbeat')
      axios.get(storeApiUrl.BACKEND_BASE_URL + 'admin_snp_cart/a2z-heartbeat')
        .then(response => {
          printDebugLog('snp ping Response:', response.data);
        })
        .catch(error => {
          printInfoLog('snp ping Error:', error);
        });
    };

    const intervalId = setInterval(keepAlive, KEEP_ALIVE_INTERVAL);
    return () => {
      clearInterval(intervalId);
    }
  }, [storeApiUrl]);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    if (getAuthSession().defInactitivityTime !== -1)
      window.addEventListener('mousemove', handleMouseMove);
    return () => {
      console.log("event listener removed")
      window.removeEventListener("keydown", handleKeyDown)
      if (getAuthSession().defInactitivityTime !== -1)
        window.removeEventListener('mousemove', handleMouseMove);
    }
  }, []);

  const SnpSocketNotificationConnect = () => {
    let parentId = encodeWithDigit("A2Z", getRandomTwoDigitNumber());
    parentId = encodeURIComponent(parentId);
    let clientId = encodeWithDigit(getAuthSession().apiToken, getRandomTwoDigitNumber());
    clientId = encodeURIComponent(clientId);
    const url = `${CHAT_SOCKET_BASE_URL}a2z-socket?wsSnpParentToken=${parentId}&wsApiToken=${clientId}`;

    // If user logged out → do not start websocket
    if (!getAuthSession().loggedIn) {
      console.log("SNP_WEBSOCKET: User logged out → skip socket start");
      return;
    }

    socketRef.current = createCartWebSocket(
      url,
      handleSocketMessage,
      () => {
        console.log("SNP_WEBSOCKET: Connected");
      },
      () => {
        console.log("SNP_WEBSOCKET: Disconnected");
        if (getAuthSession().loggedIn) {
          console.log("SNP_WEBSOCKET: ReConnecting...");
          reSnpSocketNotificationConnectTimer.current = setTimeout(SnpSocketNotificationConnect, 1000);
        } else {
          console.log("SNP_WEBSOCKET: User logged out → do not reConnecting.");
        }
      }
    );
  };

  useEffect(() => {
    SnpSocketNotificationConnect();


    return () => {
      if (socketRef.current) socketRef.current.close();
      if (reSnpSocketNotificationConnectTimer.current) clearTimeout(reSnpSocketNotificationConnectTimer.current);
    };
  }, [storeApiUrl]);


  useEffect(() => {
    //SnpFcmNotification();
    if (getAuthSession().firstTimeLogin) {
      setComponentIndex(DashboardComponent.PASSWORDDIALOG);
    }
    if (!getAuthSession().loggedIn) {
      setLogoutUser(true);
    }
    if (isChatMounted && !isEmpty(storeActiveShopHash?.id)) {
      handleOnChatAdminLoaded();
    }
    getBaseNotificationCount(storeApiUrl.BACKEND_BASE_URL, storeActiveShopHash, (count) => {
      setCount(count);
    })
  }, [isChatMounted, storeActiveShopHash]);

  useEffect(() => {
    const dashboardRoot = location.pathname === '/dashboard' || location.pathname === '/dashboard/';
    if (dashboardRoot && isChefEnabled && isFeatureAllowed(KITCHENMGMT) && getAuthSession().openKitchenAfterLogin
      && !getAuthSession().firstTimeLogin) {
      navigate('/dashboard/kitchen', { replace: true });
    }
  }, [isChefEnabled, location.pathname, navigate]);

  const handleOnChatAdminLoaded = async () => {
    printDebugLog("ChatContext:handleOnChatAdminLoaded");
    try {
      const response = await snpAxios.get(`${storeApiUrl.BACKEND_BASE_URL}get-chat-hash?token=${getAuthSession().apiToken}&shopHash=${storeActiveShopHash.id}`);
      printDebugLog("ChatContext:hashed value ", response.data);
      if (response.data.status === SUCCESS) {
        const chatHash = response.data.jcJson.chatHash;
        if (!isEmpty(chatHash)) {
          useSnpChatPublicApi.registerChatKey(storeActiveShopHash.id);
          useSnpChatPublicApi.registerUserDetails(prev => ({
            ...prev,
            id: chatHash,
            name: getAuthSession().userName,
            email: getAuthSession().userEmail,
          }));
        }
      }
    } catch (err) {
      console.error("handleOnChatAdminLoaded", err);
    }
  }

  const renderPasswordDialogContent = () => {
    return (
      <Grid container spacing={1} sx={{ display: "flex", justifyContent: "center", width: "250px" }}>
        {
          getAuthSession().firstTimeLogin && <Grid item md={12}>
            <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: "14px" }}>First Login! Please Change the Password</p>
          </Grid>
        }

        <Grid item xs={12}>
          <TextField
            disabled
            id="userName"
            label="User Name"
            name="userName"
            defaultValue={getAuthSession().userName}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            required
            id="oldPassWord"
            label="Input Old Password"
            name="oldPassWord"
            type="password"
            onChange={(e) => setPasswordDialog(prevs => ({
              ...prevs,
              oldPassWord: e.target.value,
            }))}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            required
            id="newPassWord"
            label="Input New Password"
            name="newPassWord"
            type="password"
            onChange={(e) => setPasswordDialog(prevs => ({
              ...prevs,
              newPassWord: e.target.value,
            }))}
          />
        </Grid>
        {!isEmpty(passwordDialog.message) &&
          <Grid item xs={12}>
            <p style={{
              color: "red",
              whiteSpace: 'pre-wrap',
              overflowWrap: 'break-word',
              fontSize: "11px"
            }}>{passwordDialog.message}</p>
          </Grid>
        }
      </Grid>
    );
  };

  const renderPasswordDialogAction = () => {
    return (
      <>
        <SnpButton variant="contained" color="primary" onClick={handleChangePwd}>
          Change Password
        </SnpButton>
        <DismissButton variant="contained" color="primary" onClick={() => setPasswordDialog(INITIAL_MESSAGE)}>
          Dismiss
        </DismissButton>
      </>
    );
  };

  const getProductDetailsUI = () => {
    return (
      <Paper elevation={10}
        autoHeight
        sx={{
          display: "flex",
          flexDirection: "row",
          backgroundColor: "#c0c5ce",
          boxShadow: 1,
          borderRadius: 4,
          padding: 2,
        }} >
        <div>
          <Typography
            variant="p"
            style={{ fontSize: "14px" }}
            component="div">
            <span style={{ color: "blue", fontWeight: "bold" }}>Item Name</span>
            <span style={{ margin: "0 4px" }}>:</span>
            <span style={{ color: "green", fontFamily: "monospace", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{stockDetails.details}</span>
          </Typography>
          <Typography
            variant="p"
            style={{ fontSize: "14px" }}
            component="div">
            <span style={{ color: "blue", fontWeight: "bold" }}>Type</span>
            <span style={{ margin: "0 4px" }}>:</span>
            <span style={{
              color: "green", fontFamily: "monospace", whiteSpace: 'pre-wrap',
              overflowWrap: 'break-word'
            }}>{stockDetails.type}</span>
          </Typography>
          <Typography
            variant="p"
            style={{ fontSize: "14px" }}
            component="div">
            <span style={{ color: "blue", fontWeight: "bold" }}>Rack No</span>
            <span style={{ margin: "0 4px" }}>:</span>
            <span style={{
              color: "green", fontFamily: "monospace", whiteSpace: 'pre-wrap',
              overflowWrap: 'break-word'
            }}>{stockDetails.rack_no}</span>
          </Typography>
          <Typography
            variant="p"
            style={{ fontSize: "14px" }}
            component="div">
            <span style={{ color: "blue", fontWeight: "bold" }}>Available Free Stock</span>
            <span style={{ margin: "0 4px" }}>:</span>
            <span style={{
              color: "green", fontFamily: "monospace", whiteSpace: 'pre-wrap',
              overflowWrap: 'break-word'
            }}>{stockDetails.freeLiveStockData || "No Stock Found.Add new stock"}</span>
          </Typography>
          <Typography
            variant="p"
            style={{ fontSize: "14px" }}
            component="div">
            <span style={{ color: "blue", fontWeight: "bold" }}>Available Stock</span>
            <span style={{ margin: "0 4px" }}>:</span>
            <span style={{
              color: "green", fontFamily: "monospace", whiteSpace: 'pre-wrap',
              overflowWrap: 'break-word'
            }}>{stockDetails.liveStockData || "No Stock Found.Add new stock"}</span>
          </Typography>
          {/* {
            stockManagement.liveStockOnlineData &&
            <Typography
              variant="p"
              style={{ fontSize: "14px" }}
              component="div">
              <span style={{ color: "blue", fontWeight: "bold" }}>Online Stock</span>
              <span style={{ margin: "0 4px" }}>:</span>
              <span style={{
                color: "green", fontFamily: "monospace", whiteSpace: 'pre-wrap',
                overflowWrap: 'break-word'
              }}>{stockDetails.liveStockOnlineData}</span>
            </Typography>
          } */}
          <Typography
            variant="p"
            style={{ fontSize: "14px" }}
            component="div">
            <span style={{ color: "blue", fontWeight: "bold" }}>Expired Stock</span>
            <span style={{ margin: "0 4px" }}>:</span>
            <span style={{
              color: "green", fontFamily: "monospace", whiteSpace: 'pre-wrap',
              overflowWrap: 'break-word'
            }}>{stockDetails.expiryLiveStockData || "0"}</span>
          </Typography>
        </div>
      </Paper>
    );
  }

  const renderSearchContent = () => {
    return (
      <div>
        <Grid container spacing={1}>
          <Grid item md={12} xs={12} sm={12} lg={12}>
            {searchLoader && <LinearProgress />}
            <Autocomplete
              id="search-select"
              options={listStock}
              autoHighlight
              variant="filled"
              size="small"
              fullWidth
              value={stockDetails}
              onChange={handleUpdateStockDetails}
              onBlur={(e) => setListStock([])}
              isOptionEqualToValue={(option, value) => option?.id === value?.id}
              getOptionLabel={(option) => option?.details || ''}
              inputValue={inputValue}
              onInputChange={handleItemSearchChange}
              filterOptions={(options, { inputValue }) =>
                options.filter((option) =>
                  option?.details?.toLowerCase().includes(inputValue?.toLowerCase()) ||
                  option?.prdType?.toLowerCase().includes(inputValue?.toLowerCase()) ||
                  option?.hsnCode?.toLowerCase().includes(inputValue?.toLowerCase()) ||
                  option?.tags?.toLowerCase().includes(inputValue?.toLowerCase()) ||
                  option?.catgName?.toLowerCase().includes(inputValue?.toLowerCase())
                )
              }
              renderOption={(props, option) => (
                <Box
                  component="li"
                  {...props}
                >
                  {uiUtilInstance.getStockOptionLabel(option)}
                </Box>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Search Here"
                  onChange={handleSearch}
                  inputProps={{
                    ...params.inputProps,
                  }}
                />
              )}
            />
            {/* {searchLoader && <LinearProgress/>}
            <ReusableDropdownInput
              list={listStock}
              onInputChange={(value) => {
                if (value.length >= 3) {
                  getProductDetails(value);
                }
              }}
              getOptionLabel={(option)=> uiUtilInstance.getStockOptionLabel(option)}
              placeholder="Search Here"
              onItemClick={handleUpdateStockDetails}
            /> */}
          </Grid>
          {
            isGetStockDetails &&
            <Grid item md={12} xs={12} sm={12} lg={12}>
              {getProductDetailsUI()}</Grid>
          }
        </Grid>
      </div>
    );
  };



  const renderSearchDialogAction = () => {
    return (
      <>
        <Grid item xs={12} md={6}>
          {/* <SnpButton id="gsd"
            name="gsd" disabled={!listDataAvail} variant="contained" color="primary" onClick={handleSearch} sx={{
              mx: 2
            }}>
            Get Stock Details
          </SnpButton> */}
          <SnpButton id="lse"
            name="lse" disabled={!isGetStockDetails} variant="contained" color="primary" onClick={handleSearch} sx={{
              mr: 2
            }}>
            Live Stock Entry
          </SnpButton></Grid>
        <Grid item xs={12} md={6}>
          <SnpButton id="sb"
            name="sb" disabled={!listDataAvail} variant="contained" color="primary" onClick={handleSearch} sx={{
              mr: 2
            }}>
            Start Billing
          </SnpButton>
        </Grid>
      </>
    );
  };


  const renderLockIcon = () => {
    return (
      <Avatar style={{ backgroundColor: "#1bbd7e" }}>
        <LockOutlinedIcon />
      </Avatar>
    );
  };
  const renderLockDialogContent = () => {
    return (
      <div>
        <Grid container spacing={1} sx={{ display: "flex", justifyContent: "center", width: "250px" }}>
          <Grid item md={2} xs={2}>
            {renderLockIcon()}
          </Grid>
          <Grid item md={10} xs={10}>
            <Typography variant="p" color="#02056e" fontWeight='bold' fontSize={25}>
              {getAuthSession().userName}
            </Typography>
          </Grid>
          <Grid item md={12} xs={12}>
            <TextField
              required
              id="oldPassWord"
              label="Enter Password"
              name="oldPassWord"
              type="password"
              autoComplete="current-password"
              value={lockDialog.oldPassWord}
              size="small"
              onChange={(e) => setLockDialog(prevs => ({
                ...prevs,
                oldPassWord: e.target.value,
              }))}
              onKeyDown={handleSignInKeyDown}
            />
          </Grid>
        </Grid>

        {!isEmpty(lockDialog.message) &&
          <Grid item xs={12}>
            <p style={{
              color: "red",
              whiteSpace: 'pre-wrap',
              overflowWrap: 'break-word',
              fontSize: "11px"
            }}>{lockDialog.message}</p>
          </Grid>
        }
      </div>
    );
  };

  const renderLockDialogAction = () => {
    return (
      <>
        {
          !expiryDialog.show && <SnpButton variant="contained" size="small" color="primary" onClick={signIn}>
            Sign In
          </SnpButton>
        }
        <DismissButton variant="contained" size="small" color="primary" onClick={(e) => setComponentIndex(DashboardComponent.LOGOUT)}>
          Sign Out
        </DismissButton>
      </>
    );
  }

  const renderValidityExpiryContent = () => {
    return (
      <Grid container spacing={1} sx={{ display: "flex", justifyContent: "center" }}>
        <Grid item xs={12}>
          <center>
            <Typography
              variant="p"
              component="div"
              style={{ color: "#520607", whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: '28px' }}
            >
              {expiryDialog.message}
            </Typography>
          </center>
        </Grid>
        <Grid item xs={12}>
          <Autocomplete
            id="demo-simple-select-label"
            variant="filled"
            size="small"
            autoHighlight
            options={getAuthSession().listShopHash}
            onChange={updateCartValue}
            getOptionLabel={(option) => getKeyByValue(CartDets, option)}
            defaultValue={storeActiveShopHash}
            renderOption={(props, option) => (
              <Box
                component="li"
                {...props}
              >
                {
                  storeActiveShopHash.id === option.id ?
                    <Typography textAlign="center" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', color: "#2f1160", fontWeight: 'bold' }}>{getKeyByValue(CartDets, option)}</Typography>
                    : <Typography textAlign="center" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{getKeyByValue(CartDets, option)}</Typography>
                }
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Shop Type"
                inputProps={{
                  ...params.inputProps,
                }}
                style={{ width: "100%" }}
              />
            )}
          />

        </Grid>
      </Grid>
    );
  };

  const handleVoiceCommand = (data) => {
    console.log("[Voice] COMMAND:", data);
    setLastVoiceCommand({ ...data, receivedAt: Date.now() });

    /*
      Example:

      {
        command: "select",
        target: "login button",
        raw: "select login button",
        confidence: 0.91
      }
    */

    switch (data.command) {
      case VOICE_COMMANDS.OPEN:
        console.log("[Voice]Open:", data.target);
        break;

      case VOICE_COMMANDS.SHOW:
        console.log("[Voice]SHOW:", data.target);
        break;

      case VOICE_COMMANDS.ADD:
        console.log("[Voice]Add:", data.target);
        break;

      case VOICE_COMMANDS.REMOVE:
        console.log("[Voice]Remove:", data.target);
        break;

      default:
        break;
    }
  };

  return (
    loggedOut ? offline_enable ? offlineLogout() : <Navigate replace to="/login" /> :
      <>
        <NotificationContainer />
        {/* <VoiceCommandListener
        enabled={voiceSettings.enabled}
        listenDurationMs={voiceSettings.listenDurationMs}
        language="en-IN"
        speechThreshold={voiceSettings.speechThreshold}
        speechStartDelay={voiceSettings.speechStartDelay}
        speechEndDelay={voiceSettings.speechEndDelay}
        commands={voiceSettings.commands}
        onCommand={handleVoiceCommand}
        onTranscript={(text) => {
          console.log("[Voice]Heard:", text);
        }}
        onUnrecognized={(text) => {
          console.log("Unknown command:", text);
        }}
        onSpeechStart={() => {
          console.log("[Voice]Speaking...");
        }}
        onSpeechEnd={() => {
          console.log("[Voice]Speech finished");
        }}
        onError={(error) => {
          console.error("[Voice]Error:", error);
        }}
      /> */}
        <SnpFcmNotification
          setCount={setCount}
          onNotificationMessage={handleFirebaseNotificationMessage}
        />
        <ChatSound play={fcmNotification?.show ?? false} audioSrc={fcmNotification?.audioSrc ?? ""} onFinish={() => {
          setTimeout(() => {
            setFcmNotification({
              message: '',
              show: false,
              audioSrc: "",
            });
          }, 1);
        }} />
        <GeneralNotificationDialog
          notification={generalNotifications[0]}
          onDismiss={() => setGeneralNotifications((current) => current.slice(1))}
        />
        <Box sx={{ display: "flex", height: "100dvh", overflow: "hidden" }}>
          <CssBaseline />
          {loader && <Loader />}
          <Navbar open={open}
            toggleDrawer={toggleDrawer}
            handleLoader={handleLoader}
            setComponentIndex={setComponentIndex}
            throwValidityError={handleThrowValidityErrorByShop}
            count={count}
            onReadClick={() => getBaseNotificationCount(storeApiUrl.BACKEND_BASE_URL, storeActiveShopHash, (count) => {
              setCount(count);
            })}
            onOpenRestoProductSearch={() => setGlobalRestoSearchOpen(true)}
            onOpenComboSearch={() => setGlobalComboSearchOpen(true)}
          />
          <Sidebar
            open={open}
            toggleDrawer={toggleDrawer}
            setComponentIndex={setComponentIndex}
          />
          <Box
            component="main"
            sx={{
              flexGrow: 1,
			  minWidth: 0,
			  boxSizing: "border-box",
			  height: { xs: "calc(100dvh - 56px)", sm: "calc(100dvh - 64px)" },
			  mt: { xs: "56px", sm: "64px" },
			  overflowX: "hidden",
			  overflowY: "auto",
            }}
          >
			<Container maxWidth="none" sx={{ mt: { xs: 1, sm: 2 }, mb: 6, backgroundColor: "#12h56" }}>
              <Routes>
                <Route path="/" element={getDefaultScreen()} />
                <Route path="/home" element={<FeatureGuard
                  feature={OWNERDASHBOARD}
                  Component={OwnerDashboard} />
                } />
                <Route path="/report-generation" element={<FeatureGuard
                  feature={REPGEN}
                  Component={ReportGeneration} />
                } />
                <Route path="/coupon" element={<FeatureGuard
                  feature={COUPONMANAGEMENT}
                  Component={CouponManagementFrame} />
                } />
                <Route path="/employee" element={<FeatureGuard
                  feature={EMPMGMT}
                  Component={Employee}
                  showDialogBoxWithPaper={showDialogBox}
                />
                } />
                <Route path="/employee/salary" element={<FeatureGuard
                  feature={EMPSALARYMGMT}
                  Component={EmployeeSalaryBase}
                />
                } />
                <Route path="/cateogory" element={<FeatureGuard
                  feature={[INVSTOCKMGMT, FOODITEMPRODUCTMGMT]}
                  Component={Category}
                  showDialogBoxWithPaper={showDialogBox}
                />
                } />
                <Route path="/goldsupplierrecord" element={<FeatureGuard
                  feature={[INVSTOCKMGMT]}
                  Component={GoldSupplierRecord}
                />
                } />
                <Route path="/showgoldsupplierrecord" element={<FeatureGuard
                  feature={[INVSTOCKMGMT]}
                  Component={ShowGoldSupplierRecord}
                />
                } />
                <Route path="/gold-stock" element={<FeatureGuard
                  feature={[INVSTOCKMGMT]}
                  Component={GoldPdp}
                />
                } />
                <Route path="/itementry" element={<FeatureGuard
                  feature={[FOODITEMPRODUCTMGMT]}
                  Component={storeActiveShopHash.cartType === CartDets.Resto ? RestoProductStock : ProductEntry}
                />
                } />
                <Route path="/showproduct" element={<FeatureGuard
                  feature={[INVSTOCKMGMT]}
                  Component={ShowProduct}
                />
                } />
                <Route path="/productentry" element={<FeatureGuard
                  feature={[INVSTOCKMGMT]}
                  Component={AddProductBase}
                />
                } />
                <Route path="/supplier" element={<FeatureGuard
                  feature={SUPMGMT}
                  Component={SupplierInfo}
                  showDialogBoxWithPaper={showDialogBox}
                />
                } />
                <Route path="/stockentry" element={
                  <FeatureGuard
                    feature={STOCKMGMT}
                    Component={storeActiveShopHash.cartType === CartDets.Resto ? RestoStockInformation : StockEntry}
                    showDialogBoxWithPaper={showDialogBox}
                  />
                }
                />
                <Route path="/customunit" element={<FeatureGuard
                  feature={CUSTOMUNITMGMT}
                  Component={Conversion}
                  showDialogBoxWithPaper={showDialogBox}
                />
                } />
                <Route path="/billhandler" element={<FeatureGuard
                  feature={BILLMGMT}
                  Component={storeActiveShopHash.cartType === CartDets.Resto ? BillingTable : BillConnector}
                  showDialogBoxWithPaper={showDialogBox}
                  voiceCommand={lastVoiceCommand}
                  setVoiceCommandClear={() => setLastVoiceCommand(null)}
                />
                } />
                <Route path="/voice-settings" element={<FeatureGuard
                  feature={VOICEMGMT}
                  Component={A2zVoiceSettings}
                />
                } />
                <Route path="/printer-configuration" element={<FeatureGuard
                  feature={CUSTOMIZEDCONFIG}
                  Component={PrinterConfig}
                />
                } />
                <Route path="/ecart" element={<ThemeManager showDialogBoxWithPaper={showDialogBox} />} />
                <Route path="/customer" element={<FeatureGuard
                  feature={CUSTOMERMGMT}
                  Component={Customer}
                  showDialogBoxWithPaper={showDialogBox}
                />
                } />
                <Route path="/profile" element={<Profile throwValidityError={handleThrowValidityErrorByShop} />} />
                <Route path="/accounting" element={<FeatureGuard
                  feature={ACTMGMT}
                  Component={Accounting}
                  showDialogBoxWithPaper={showDialogBox}
                />
                } />
                <Route path="/tableconfig" element={storeActiveShopHash.cartType === CartDets.Resto ? <BookTable /> : null} />
                <Route path="/billentry" element={<FeatureGuard
                  feature={[BILLMGMT, ONLINEBILLMGMT]}
                  Component={storeActiveShopHash.cartType === CartDets.Resto
                    ? (getAuthSession().defBillUi === 1 ?
                      RestoBillingModule
                      : getAuthSession().defBillUi === 2
                        ? RestoKeyboardBase
                        :  getAuthSession().defBillUi === 3 ? RestoBillingModuleV2 : RestoBillingModuleV3)  : MartBilling}
                />
                } />
                <Route path="/showbills" element={<FeatureGuard
                  feature={[BILLMGMT, ONLINEBILLMGMT]}
                  Component={ShowBills}
                />
                } />
                <Route path="/comboentry" element={<FeatureGuard
                  feature={[COMBOMGMT, COMBOFOODITEMGMT]}
                  Component={ComboOffer}
                />
                } />
                <Route path="/configuration" element={<FeatureGuard
                  feature={CUSTOMIZEDCONFIG}
                  Component={Configuration}
                />
                } />
                <Route path="/recharge-portal" element={<Recharge/> } />
                <Route path="/marketing" element={<MarketingPage/> } />
                <Route path="/trackrider" element={<FeatureGuard
                  feature={CUSTOMERRIDERAPP}
                  Component={RiderDashBoard}
                />
                } />
                <Route path="/itemsaledashboard" element={<FeatureGuard
                  feature={SHOWITEMWISESALES}
                  Component={ItemSaleDashboard}
                />
                } />
                <Route path="/returnwastebill" element={<FeatureGuard
                  feature={RETURNWASTEMGMT}
                  Component={storeActiveShopHash.cartType === CartDets.Resto ? ReturnWasteBill : MartReturnWasteBill}
                />
                } />
                <Route path="/onlinebill" element={<FeatureGuard
                  feature={BILLMGMT}
                  Component={OnlineWatchBill}
                />
                } />
                <Route path="/receipe" element={<FeatureGuard
                  feature={RECPMGMT}
                  Component={ReceipeV2}
                />
                } />
                <Route path="/kitchen" element={isChefEnabled ? <FeatureGuard
                  feature={KITCHENMGMT}
                  Component={KitchenUI}
                /> : <Navigate replace to="/dashboard" />} />
                <Route path="/minrangedistance" element={<MinimumOrderDistance />
                } />
                <Route path="/notification" element={<ScreenNotificationScreen onReadClick={() => getBaseNotificationCount(storeApiUrl.BACKEND_BASE_URL, storeActiveShopHash, (count) => {
                  setCount(count);
                })} />
                } />
                <Route path="/help" element={<HelpModule />} />
                <Route path="/pay-info" element={<PaymentInformation/>
                } />
              </Routes>
              {
                (isFeatureAllowed(CHATSUPPMGMT) && isRoleAllowed(CHATSUPPMGMT, ROLE_VIEW)) &&
                <SnpChatApp use_admin={true} onAdminMounted={() => setIsChatMounted(true)} />
              }

            </Container>
          </Box>
        </Box>
        <ConfirmDialog isOpen={confirmDialog.showDialog}
          title={confirmDialog.title}
          subTitle={confirmDialog.subTitle}
          negativeAction={confirmDialog.negativeAction}
          positiveReq={confirmDialog.positiveReq}
          onClose={() => setConfirmDialog(INITIAL_DIALOG_CONTENT)}
          iconReq={confirmDialog.iconReq}
          onCancel={confirmDialog.onHandleCancel}
          cancelExtra={confirmDialog.cancelConfirmExtra}
          outsideClickedDismiss={confirmDialog.outsideClickedConfirmDismiss}
          onSubmit={() => setComponentIndex(DashboardComponent.LOGOUT)}
        />
        <SilentPrintDecisionManager />
        <GlobalRestoProductSearch
          open={globalRestoSearchOpen}
          onClose={() => setGlobalRestoSearchOpen(false)}
          onSelect={(item) => {
            if (isRoleAllowed(STOCKMGMT, ROLE_UPDATE)) {
              return true;
            }
            showDialogBox("You Are not allowed to Add/Update Stock Details.Contact the Owner");
            return false;
          }}
          baseUrl={storeApiUrl.BACKEND_BASE_URL}
          shopHash={storeActiveShopHash.id}
        />
        <GlobalRestoBulkStock
          open={globalRestoBulkStockOpen}
          onClose={() => setGlobalRestoBulkStockOpen(false)}
          onSaved={(count) => showDialogBox(`${count} stock ${count === 1 ? "entry" : "entries"} added successfully.`)}
          baseUrl={storeApiUrl.BACKEND_BASE_URL}
          shopHash={storeActiveShopHash.id}
          cartType={storeActiveShopHash.cartType}
        />
        <GlobalComboSearch
          open={globalComboSearchOpen}
          onClose={() => setGlobalComboSearchOpen(false)}
          onSelect={(combo) => {
            if (isRoleAllowed([INVSTOCKMGMT, FOODITEMPRODUCTMGMT], ROLE_CREATE)) {
              setGlobalComboId(combo.id);
            } else {
              showDialogBox("You Are not allowed to Update Combo Details.Contact the Owner");
            }
          }}
          baseUrl={storeApiUrl.BACKEND_BASE_URL}
          shopHash={storeActiveShopHash.id}
          cartType={storeActiveShopHash.cartType}
        />
        {globalComboId ? (
          <ComboOffer
            globalEditor
            globalComboId={globalComboId}
            onGlobalEditorClose={() => setGlobalComboId("")}
          />
        ) : null}
        <DialogBox
          showDialog={passwordDialog.show}
          title="Change Password"
          onClose={() => setPasswordDialog(INITIAL_MESSAGE)}
          dialogContent={renderPasswordDialogContent()}
          dialogActions={renderPasswordDialogAction()}
        />
        <DialogBox
          showDialog={searchDialog.show}
          title="Search By Item or Brand Name"
          onClose={() => {
            setSearchDialog(INITIAL_MESSAGE);
            setIsGetStockDetails(false);
            setListDataAvail(false);
            setStockDetails(INITIAL_STOCK_CONTENT);
            setInputValue('');
          }}
          dialogContent={renderSearchContent()}
          dialogActions={renderSearchDialogAction()}
        />
        <DialogBox
          showDialog={lockDialog.show}
          title="Unlock"
          outsideClickedDismiss={false}
          onClose={() => setLockDialog(INITIAL_MESSAGE)}
          dialogContent={renderLockDialogContent()}
          dialogActions={renderLockDialogAction()}
        />
        <DialogBox
          showDialog={expiryDialog.show}
          title="Validity Expired"
          outsideClickedDismiss={false}
          onClose={() => setExpiryDialog(INITIAL_MESSAGE)}
          dialogContent={renderValidityExpiryContent()}
          dialogActions={renderLockDialogAction()}
        />
      </>
  )
}
